var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"m-contents-title"},[_c('span',{staticClass:"m-q"},[_c('en',{attrs:{"s":_vm.title}}),(_vm.sub)?_c('div',{staticClass:"m-separator-v"}):_vm._e(),_c('en',{attrs:{"s":_vm.sub}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }